import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class LimitCustomerResource extends BaseCamelCasedResource {
    pk() {
        return this.limitCustomerId?.toString() || "";
    }
    /**
     * Get the url for many Resources
     */
    static listUrl(allParams = {}) {
        const { applicationId } = allParams;
        if (applicationId !== undefined) {
            return `${this.urlRoot}/get-limit-customers-for-app/${applicationId}`;
        }
        throw new Error("LimitCustomerResource require applicationId");
    }
}
LimitCustomerResource.urlRoot = apiResourceUrl("limit-customer");
//# sourceMappingURL=LimitCustomerResource.js.map